<template>
  <div class="event-list">
    <!-- Collapse -->
    <button
      class="collapse-btn"
      :class="{ active: isCollapsed }"
      @click="collapse"
    >
      <i class="icon icon--arrow"></i>
      <span>{{ activeCategory }}</span>
    </button>
    <transition name="smooth-collapse">
      <div v-if="isCollapsed" class="collapse">
        <div
          v-for="(category, index) in sortedCategories"
          :key="index"
          class="collapse__item"
        >
          <span @click="selectCategory(category)">{{ category }}</span>
        </div>
      </div>
    </transition>
    <!-- Event list -->
    <loader v-if="!loaded" />
    <div v-else class="event-list__list">
      <div v-if="sortedEvents.length === 0">Ei tapahtumia.</div>
      <event-item
        v-for="event in sortedEvents"
        :key="event.id"
        :color="event.category.background"
        :start="event.start"
        :end="event.end"
        :title="event.title"
        :description="event.description"
        @edit="
          $router.push({
            name: 'EditEvent',
            params: { companyId: company.id, event_slug: event.slug }
          })
        "
        @delete="deleteEvent(event.id)"
      />
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import { mapState } from "vuex";
import moment from 'moment'

import EventItem from "@/components/EventItem";
import Loader from "@/components/Loader";

export default {
  name: "EventList",
  components: {
    EventItem,
    Loader
  },
  props: {
    year: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isCollapsed: false,
      events: [],
      categories: [],
      activeCategory: "Kaikki kategoriat",
      loaded: false,
      event: null,
      companyId: null,
      unsubscribe: null,
    };
  },
  destroyed() {
    if(this.unsubscribe != null) {
      this.unsubscribe();
    }
  },
  mounted() {
    if(this.company == null) {
      return;
    }
    this.categories = this.company.categories;

// return;
    this.unsubscribe = db.collection(`companies/${this.company.id}/events`).onSnapshot(snapshot => {
      this.events = [];
      snapshot.forEach(doc => {
        let event = doc.data();
        event.id = doc.id;
        this.events.push(event);
      });
      this.loaded = true;
    });
    // let user = firebase.auth().currentUser;
    // let uid = user.uid;

    // db.collection("users")
    //   .doc(uid)
    //   .get()
    //   .then(doc => {
    //     let data = doc.data();
    //     this.companyId = data.companyId;
    //   })
    //   .then(() => {
    //     db.collection("companies")
    //       .doc(this.companyId)
    //       .get()
    //       .then(doc => {
    //         let company = doc.data();
    //         company.categories.map(category => {
    //           this.categories.push(category);
    //         });
    //       });
    //   })
    //   .then(() => {

    //   })
    //   .catch(err => {
    //     console.log("Virhe", err);
    //   });
  },
  methods: {
    collapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    selectCategory(i) {
      this.activeCategory = i;
      this.isCollapsed = !this.isCollapsed;
    },
    deleteEvent(id) {
      db.collection(`companies/${this.company.id}/events`)
        .doc(id)
        .delete()
        .then(() => {
          this.events = this.events.filter(event => {
            return event.id !== id;
          });
        });
    }
  },
  computed: {
    ...mapState(["user", "company"]),
    sortedCategories() {
      // const sortedEvents = this.events.map(ev => ev.category.title);
      const sortedCategories = this.categories.map(cat => cat.title);

      // const sortedTotal = sortedEvents.filter(obj1 =>
      //   sortedCategories.some(obj2 => obj1.id === obj2.id)
      // );
      // let cats = this.categories.map(cat => cat.title);

      // sortedTotal.push("Kaikki kategoriat");

      return [...sortedCategories, "Kaikki kategoriat"];
    },
    sortedEvents() {
      let filterEvents = [...this.events]
        .filter(ev => {
          let eventCategory = ev.category.title;
          let active = this.activeCategory;
          
          const startYear = moment(ev.start,'DD.MM.YYYY').toDate().getFullYear();
          const endYear = moment(ev.end,'DD.MM.YYYY').toDate().getFullYear();
          return eventCategory.includes(active) && (startYear == this.year || startYear < this.year && endYear >= this.year);
        })
        .sort((a, b) => {
          let dateA = a.start.split(".").join("");
          let dateB = b.start.split(".").join("");

          return dateA < dateB ? 1 : dateA > dateB ? -1 : 0;
        });

      let sortedEvents = [...this.events].sort((a, b) => {
        let dateA = a.start.split(".").join("");
        let dateB = b.start.split(".").join("");

        return dateA < dateB ? 1 : dateA > dateB ? -1 : 0;
      });

      sortedEvents = sortedEvents.filter(ev => { 
        const startYear = moment(ev.start,'DD.MM.YYYY').toDate().getFullYear();
        const endYear = moment(ev.end,'DD.MM.YYYY').toDate().getFullYear();
        return (startYear == this.year || startYear < this.year && endYear >= this.year);
      })
      filterEvents = filterEvents.filter(ev => { 
        const startYear = moment(ev.start,'DD.MM.YYYY').toDate().getFullYear();
        const endYear = moment(ev.end,'DD.MM.YYYY').toDate().getFullYear();
        return (startYear == this.year || startYear < this.year && endYear >= this.year);
      })

      if (this.activeCategory === "Kaikki kategoriat") {
        return sortedEvents;
      } else {
        return filterEvents;
      }
    }
  }
};
</script>

<style lang="scss">
.event-list {
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 50rem;
  width: 100%;
  max-height: 40rem;
  min-height: 40rem;
  padding: 1em 1em 2em;
  background: white;
  border-radius: 1.5rem;
  box-shadow: $shadow_sm;
  overflow: hidden;
  @include bp(sm) {
    min-width: 40rem;
    padding: 1em 2em 2em;
  }
  &__list {
    width: 100%;
    max-height: 20em;
    margin-top: 1em;
    padding: 0 1em;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: $whitegray;
    }
    &::-webkit-scrollbar-thumb {
      background: $lightred;
      border-radius: 10rem !important;
    }
  }
}
.collapse-btn {
  position: relative;
  width: 100%;
  padding: 0.5em 2em;
  border-radius: 2.5em;
  border: none;
  outline: none;
  color: white;
  font-size: 1.6rem;
  font-weight: bold;
  background: $lightred;
  cursor: pointer;
  &.active {
    i {
      transform: rotate(180deg);
      transition: $transition;
    }
  }
  i {
    position: absolute;
    left: 1em;
    transition: $transition;
    @include bp(sm) {
      left: 2em;
    }
  }
}
.collapse {
  width: 100%;
  height: 100%;
  margin-top: 0.5em;
  padding: 1em 2em;
  color: white;
  text-align: center;
  background: $lightred;
  border-radius: 1.5em;
  &__item {
    width: 100%;
    padding: 5px 0;
    span {
      display: inline-block;
      width: 100%;
      cursor: pointer;
    }
  }
}
.smooth-collapse-enter-active {
  animation: smooth 0.25s ease-in-out;
}
.smooth-collapse-leave-active {
  animation: smooth 0.25s reverse ease-in-out;
}
@keyframes smooth {
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
}
</style>
